"use client";

import { _Link, ProductCard as PC } from "@/components/atoms";
import getLink from "@/lib/storyblok/utils/getLink";
import { CollectionPreviewStoryblok } from "@/types/storyblok-blok-types";
import { SbBlokData, storyblokEditable } from "@storyblok/js";
import clsx from "clsx";
import { useInView } from "react-intersection-observer";
import styles from "./collection-preview.module.css";
import { fetchCollectionProducts } from "./fetchers";

const CollectionPreview = ({
  blok,
  data,
}: {
  blok: CollectionPreviewStoryblok;
  data?: Awaited<ReturnType<typeof fetchCollectionProducts>>;
}) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  if (!data?.length) return null;

  const CTA = () => {
    if (!blok.link?.[0]) return null;
    const link = blok.link?.[0];
    const url = getLink(link.link);
    const text = link.text;
    return (
      <_Link href={url || ""} size="large" underlined color="dark" icon="plus">
        {text}
      </_Link>
    );
  };

  return (
    <div
      ref={ref}
      {...storyblokEditable(blok as unknown as SbBlokData)}
      data-blok
      data-animated="custom"
      data-view={inView}
      data-layout="page"
      className={clsx("collection-preview", styles.root)}
    >
      <div className={styles.left}>
        <div className={styles.details}>
          <h2 className={styles.title}>{blok.title}</h2>
          <div className={styles.description}>{blok.description}</div>
          <CTA />
        </div>
      </div>

      <div className={styles.right}>
        <div className={styles.product__grid}>
          {data?.length &&
            data.at(0) &&
            data?.map((product) => <PC product={product} key={product.id} />)}
        </div>
      </div>
    </div>
  );
};

export default CollectionPreview;
